/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackAddPaymentOrderRequestSchema } from "./pluginPostbackAddPaymentOrderRequestSchema.ts";

export const callbackPluginAddPaymentCreateStatus200Schema = z.any();

export const callbackPluginAddPaymentCreateResponseSchema = callbackPluginAddPaymentCreateStatus200Schema;

export const callbackPluginAddPaymentCreateDataSchemaJson = pluginPostbackAddPaymentOrderRequestSchema;

export const callbackPluginAddPaymentCreateDataSchemaXml = pluginPostbackAddPaymentOrderRequestSchema;

export const callbackPluginAddPaymentCreateDataSchema = z.union([callbackPluginAddPaymentCreateDataSchemaJson, callbackPluginAddPaymentCreateDataSchemaXml]);
